import { BOUNCE_RATE_PAGES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/bounce-rate-pages.definition';
import { DOCUMENTS_WITHOUT_DOWNLOADS_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/documents-without-downloads.definition';
import {
    EXTERNAL_REFERRING_DOMAINS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/external-referring-domains.definition';
import { ENTRY_PAGES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/entry-pages.definition';
import { EXIT_PAGES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/exit-pages.definition';
import { LEAST_POPULAR_PAGES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/least-popular-pages.definition';
import { MOST_DOWNLOADS_PAGES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/most-downloads-pages.definition';
import { MOST_POPULAR_PAGES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/most-popular-pages.definition';
import { PAGES_WITHOUT_VISITS_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/pages-without-visits.definition';
import { SEARCH_ENGINES_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/search-engines.definition';
import { SOCIAL_NETWORKS_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/social-networks.definition';
import {
    VISITORS_BROWSERS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-browsers.definition';
import {
    VISITORS_DEVICES_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-devices.definition';
import {
    VISITORS_LANGUAGES_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-languages.definition';
import {
    VISITORS_LOCATION_CITIES_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-location-cities.definition';
import {
    VISITORS_LOCATION_REGIONS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-location-regions.definition';
import {
    VISITORS_LOCATIONS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-locations.definition';
import {
    VISITORS_OPERATING_SYSTEMS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-operating-systems.definition';
import {
    VISITORS_ORGANIZATIONS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-organizations.definition';
import {
    VISITORS_SCREEN_RESOLUTIONS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/visitors-screen-resolutions.definition';
import { SITE_SEARCH_DEFINITION } from '@client/app/feature-modules/site-analytics/definitions/site-search.definition';
import {
    EVENTS_CATEGORIES_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/events-categories.definition';
import {
    EVENTS_ACTIONS_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/events-actions.definition';
import {
    EVENTS_NAMES_DEFINITION,
} from '@client/app/feature-modules/site-analytics/definitions/events-names.definition';
import type { SiteAnalyticsPageDefinition } from '@client/app/feature-modules/site-analytics/types/site-analytics-page-definition.type';
import type { SiteAnalyticsDataSourceKey } from '@client/app/feature-modules/site-analytics/types/site-analytics-page-scaffold.type';

export const SITE_ANALYTICS_PAGE_DEFINITIONS: Record<
    SiteAnalyticsDataSourceKey,
    SiteAnalyticsPageDefinition
> = {
    mostPopularPages: MOST_POPULAR_PAGES_DEFINITION,
    leastPopularPages: LEAST_POPULAR_PAGES_DEFINITION,
    mostDownloads: MOST_DOWNLOADS_PAGES_DEFINITION,
    pagesWithoutVisits: PAGES_WITHOUT_VISITS_DEFINITION,
    documentsWithoutDownloads: DOCUMENTS_WITHOUT_DOWNLOADS_DEFINITION,
    entryPages: ENTRY_PAGES_DEFINITION,
    exitPages: EXIT_PAGES_DEFINITION,
    bounceRatePages: BOUNCE_RATE_PAGES_DEFINITION,
    searchEngines: SEARCH_ENGINES_DEFINITION,
    socialNetworks: SOCIAL_NETWORKS_DEFINITION,
    externalReferringDomains: EXTERNAL_REFERRING_DOMAINS_DEFINITION,
    visitorsLocations: VISITORS_LOCATIONS_DEFINITION,
    visitorsLocationRegions: VISITORS_LOCATION_REGIONS_DEFINITION,
    visitorsLocationCities: VISITORS_LOCATION_CITIES_DEFINITION,
    visitorsLanguages: VISITORS_LANGUAGES_DEFINITION,
    visitorsOrganizations: VISITORS_ORGANIZATIONS_DEFINITION,
    visitorsDevices: VISITORS_DEVICES_DEFINITION,
    visitorsBrowsers: VISITORS_BROWSERS_DEFINITION,
    visitorsOperatingSystems: VISITORS_OPERATING_SYSTEMS_DEFINITION,
    visitorsScreenResolutions: VISITORS_SCREEN_RESOLUTIONS_DEFINITION,
    siteSearch: SITE_SEARCH_DEFINITION,
    eventsCategories: EVENTS_CATEGORIES_DEFINITION,
    eventsActions: EVENTS_ACTIONS_DEFINITION,
    eventsNames: EVENTS_NAMES_DEFINITION,
};
